var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTgGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mingcute:telegram-fill",
    clipPath: "url(#clip0_459_37104)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.3692 5.90662C26.6987 5.76794 27.0593 5.72011 27.4136 5.76811C27.7678 5.81611 28.1027 5.95818 28.3834 6.17953C28.6642 6.40089 28.8804 6.69344 29.0097 7.02673C29.139 7.36002 29.1766 7.72187 29.1185 8.07462L26.0945 26.4173C25.8012 28.1866 23.8599 29.2013 22.2372 28.32C20.8799 27.5826 18.8639 26.4466 17.0505 25.2613C16.1439 24.668 13.3665 22.768 13.7079 21.416C14.0012 20.26 18.6679 15.916 21.3345 13.3333C22.3812 12.3186 21.9039 11.7333 20.6679 12.6666C17.5985 14.984 12.6705 18.508 11.0412 19.5C9.60386 20.3746 8.85453 20.524 7.95853 20.3746C6.32386 20.1026 4.80786 19.6813 3.57053 19.168C1.89853 18.4746 1.97986 16.176 3.5692 15.5066L26.3692 5.90662Z",
    fill: "#37D881"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_459_37104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTgGreen);
export default __webpack_public_path__ + "static/media/tg_green.358eafe4718d75773126771b23b09c62.svg";
export { ForwardRef as ReactComponent };